var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"s-outer"},[_c('h1',[_vm._v("Short Term Memory")]),(!_vm.filled)?_c('Sheet',{on:{"sheetfinish":_vm.sheetFinish}}):_vm._e(),(_vm.filled)?_c('Test',{attrs:{"sheet":_vm.sheet},on:{"end":_vm.end}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }